module.exports = __webpack_public_path__ + "static/media/data-error-icon.43859947.svg";